import React, { forwardRef } from 'react'
import MatrixMessageEvent from 'matrix-react-sdk/lib/components/views/messages/MessageEvent'

const bodyTypes = {
  'm.text': 'messages.TextualBody',
  'm.sticker': 'messages.MStickerBody',
  'm.notice': 'messages.TextualBody',
  'm.emote': 'messages.TextualBody',
  'm.image': 'messages.MImageBody',
  'm.file': 'messages.MFileBody',
  'm.audio': 'messages.MAudioBody',
  'm.video': 'messages.MVideoBody',
  'g.shadow': 'messages.ShadowBody',
}

const MessageEvent = forwardRef((props, ref) => {
  return (
    <MatrixMessageEvent
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      bodyTypes={bodyTypes}
      ref={ref}
    />
  )
})

export default MessageEvent
